"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PulsingDot = PulsingDot;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const PulsingDot_Style_1 = require("./PulsingDot.Style");
function PulsingDot(props) {
    return ((0, jsx_runtime_1.jsxs)(PulsingDot_Style_1.StyledPulsingDotContainer, { children: [(0, jsx_runtime_1.jsx)(PulsingDot_Style_1.StyledDot, {}), props.pulsing && (0, jsx_runtime_1.jsx)(PulsingDot_Style_1.StyledCircle, {})] }));
}
